'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeTracking = initializeTracking;
exports.trackEvent = trackEvent;
exports.setCustomVariable = setCustomVariable;
exports.trackEventWithCustomData = trackEventWithCustomData;
function initializeTracking(_ref) {
  var url = _ref.url,
      siteId = _ref.siteId,
      _ref$secure = _ref.secure,
      secure = _ref$secure === undefined ? false : _ref$secure,
      _ref$scriptName = _ref.scriptName,
      scriptName = _ref$scriptName === undefined ? 'piwik.js' : _ref$scriptName;

  if (!url || !siteId) {
    throw new Error('Url and site id are required');
  }

  window._paq = window._paq || [];

  if (url.indexOf('//') === -1) {
    url = secure === true ? 'https://' + url + '/' : 'http://' + url + '/';
  }

  window._paq.push(['setSiteId', siteId]);
  window._paq.push(['setTrackerUrl', url + 'piwik.php']);

  var scriptElement = document.createElement('script');
  var refElement = document.getElementsByTagName('script')[0];

  scriptElement.type = 'text/javascript';
  scriptElement.defer = true;
  scriptElement.async = true;
  scriptElement.src = '' + url + scriptName;
  refElement.parentNode.insertBefore(scriptElement, refElement);
}

function trackEvent(category, action, name) {
  window._paq.push(['trackEvent', category, action, name]);
}

function setCustomVariable(slot, id, value, scope) {
  window._paq.push(['setCustomVariable', slot, id, value, scope]);
}

function trackEventWithCustomData(category, action, name, customData) {
  if (customData && window._paq && typeof window._paq.push === 'function') {
    window._paq.push(['appendToTrackingUrl', 'user_data=' + JSON.stringify(customData)]);
    trackEvent(category, action, name);
  }
}